<template>
  <div class="profileChangeSettings" id="profileChangeSettings">

    <NavigationBar>
      <template v-slot:left>
        <img v-on:click="goBack" class="back" src="../assets/icons/ic_16_back.svg" data-testid="nav-back">
      </template>
      <template v-slot:center>
        {{ $t('profile.view_settings') }}
      </template>
      <template v-slot:right>
      </template>
    </NavigationBar>

    <div class="input-container" style="margin-top: 16px;">
      <div>
        <div class="input-header">
          {{ $t('menu.bet') }}
        </div>
        <div class="input-infotext">
          {{ $t('profile.bet_hide_past_matches') }}
        </div>
        <div class="input-checkbox">
          <input id="hidePastMatches" type="checkbox" v-model="betHidePastMatches" v-on:change="hideChanged()" data-testid="profile-settings-hide-past-matches"/>
          <label for="hidePastMatches">{{ $t('hide') }}</label>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import NavigationBar from './../components/NavigationBar'

export default {
  name: 'profileChangeSettings',
  components: { NavigationBar },
  data () {
    return {
      betHidePastMatches: false
    }
  },
  created () {
    this.betHidePastMatches = window.localStorage.getItem('spmbethidepast') === 'true'
  },
  methods: {
    goBack () {
      this.$router.push('/profile')
    },
    hideChanged () {
      window.localStorage.setItem('spmbethidepast', '' + this.betHidePastMatches)
    },
  }
}
</script>

<style lang="scss" scoped>
.profileChangeSettings {

  form {
    padding-top: 16px;
  }

  h1 {
    text-align: center;
  }

  p {
    text-align: center;
    margin-bottom: 26px;
  }
}
</style>
